
import { Component, Vue, Prop } from "vue-property-decorator";

import EmployeeIcon from "@/pages/Layout/views/Employer/views/Home/assets/employee.svg";
import EmployeeIconDisabled from "@/pages/Layout/views/Employer/views/Home/assets/employee-disabled.svg";

const CLASS = "block";

const TYPE_DEFAULT = "";
const TYPE_BLUE = "blue";
const TYPE_PURPLE = "purple";

const TYPES = [TYPE_DEFAULT, TYPE_BLUE, TYPE_PURPLE];

@Component
export default class IconBlock extends Vue {
  @Prop({ type: String, default: "" }) readonly label!: string;
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;
  @Prop({ type: String, default: EmployeeIcon }) readonly image!: string;
  @Prop({ type: String, default: "" }) readonly hint!: string;
  @Prop({
    type: String,
    validator: (value: string) => TYPES.includes(value),
    default: TYPE_DEFAULT,
  })
  readonly type?: string;

  employeeIcon = EmployeeIcon;
  employeeIconDisabled = EmployeeIconDisabled;

  get classes() {
    const { disabled, type } = this;

    return {
      [`${CLASS}-active`]: !disabled,
      [`${CLASS}-disabled`]: disabled,
      [`${CLASS}-${TYPE_BLUE}`]: type === TYPE_BLUE,
      [`${CLASS}-${TYPE_PURPLE}`]: type === TYPE_PURPLE,
    };
  }

  get hintText() {
    if (this.disabled) return this.hint;

    return "";
  }

  onClick() {
    this.$emit("click");
  }
}
